import { useEffect } from 'react'
import styles from './chatBoxPage.module.scss'
import { useNavigate, useLocation } from 'react-router-dom'
import { COMMENT_OPEN, COMMENT_NEW } from '@BUP/constants'
import { useTranslation } from 'react-i18next'
import PageLayout from '@BUP/components/Layout/Page'
import ChatBoxMessages from '@BUP/components/ModeBUP/ChatBoxMessages'

const ChatBoxPage = () => {
  const navigate = useNavigate()
  const [t] = useTranslation()
  const location = useLocation()
  const { mainMessage } = location.state || {}
  // TODO
  const isMessageOpen =
    mainMessage?.state === COMMENT_OPEN || mainMessage?.state === COMMENT_NEW
  useEffect(() => {
    if (!mainMessage) {
      navigate('/modebup/inbox')
    }
  }, [navigate, mainMessage])

  return (
    <PageLayout
      pageName={t('pages.modeBup.direct.breadcrumbText4')}
      backButton
    >
      <div className={styles.chat_box_page_container}>
        <div className={styles.chat_box_wrapper}>
          <ChatBoxMessages
            mainMessage={mainMessage}
            isMessageOpen={isMessageOpen}
          />
        </div>
      </div>
    </PageLayout>
  )
}

export default ChatBoxPage
